import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCamera5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCamera5"><Path fillRule="evenodd" clipRule="evenodd" d="M11.5 4V14.5H22V21H2V4H11.5ZM5 16.4999H9V17.9999H5V16.4999Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M22 4H13V13H22V4ZM16.5 8.5C16.5 9.05228 16.9477 9.5 17.5 9.5C18.0523 9.5 18.5 9.05228 18.5 8.5C18.5 7.94772 18.0523 7.5 17.5 7.5C16.9477 7.5 16.5 7.94772 16.5 8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCamera5;
